import { docketRouteConfig } from './routes/docket.routes';
import { memberListRouteConfig } from './routes/member-list.routes';
import { memberPageRouteConfig } from './routes/member-page.routes';
import { callsPageRouteConfig } from './routes/calls-page.routes';
import { guideListPageRouteConfig } from './routes/guide-list.routes';
import { trainingAdminPageRouteConfig } from './routes/training-admin.routes';
import { loginPageRouteConfig } from './routes/login.routes';
import { avonPatientRouteConfig } from './routes/avon-patient.routes';
import { adminDashboardRouteConfig } from './routes/admin-dashboard-routes';
import { hospitalizationRouteConfig } from './routes/hospitalization.routes';
import { noAccessPageRouteConfig } from './routes/no-access.routes';

export const useAppNavigation = () => ({
  ...docketRouteConfig.useNavigationHooks(),
  ...memberListRouteConfig.useNavigationHooks(),
  ...memberPageRouteConfig.useNavigationHooks(),
  ...callsPageRouteConfig.useNavigationHooks(),
  ...guideListPageRouteConfig.useNavigationHooks(),
  ...trainingAdminPageRouteConfig.useNavigationHooks(),
  ...loginPageRouteConfig.useNavigationHooks(),
  ...avonPatientRouteConfig.useNavigationHooks(),
  ...adminDashboardRouteConfig.useNavigationHooks(),
  ...hospitalizationRouteConfig.useNavigationHooks(),
  ...noAccessPageRouteConfig.useNavigationHooks(),
});

